import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
/**
 * Check if user needs to accept new consent (Privacy Policy or Terms & Conditions)
 */
export var api__checkConsentRequired = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(currentTermsVersion, currentPolicyVersion) {
    var _res$data;
    var params, queryString, url, res, _res$data2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = new URLSearchParams();
          params.append('terms_version', currentTermsVersion);
          params.append('privacy_version', currentPolicyVersion);
          queryString = params.toString();
          url = queryString ? "/consent/check?".concat(queryString) : '/consent/check';
          _context.n = 1;
          return fetcher().get(url);
        case 1:
          res = _context.v;
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.success)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data);
        case 2:
          return _context.a(2, null);
      }
    }, _callee);
  }));
  return function api__checkConsentRequired(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Accept current Privacy Policy and Terms & Conditions versions
 */
export var api__acceptConsent = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var _res$data3;
    var res, _res$data4;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().post("/consent/accept");
        case 1:
          res = _context2.v;
          if (!(res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.success)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data);
        case 2:
          return _context2.a(2, null);
      }
    }, _callee2);
  }));
  return function api__acceptConsent() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Fetch Privacy Policy content
 */
export var api__fetchPrivacyPolicyData = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(req) {
    var _res$data5;
    var res, _res$data6;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return fetcher(req).get("/policies/privacy-policy");
        case 1:
          res = _context3.v;
          if (!(res !== null && res !== void 0 && (_res$data5 = res.data) !== null && _res$data5 !== void 0 && _res$data5.success)) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.data);
        case 2:
          return _context3.a(2, null);
      }
    }, _callee3);
  }));
  return function api__fetchPrivacyPolicyData(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Fetch Terms & Conditions content
 */
export var api__fetchTermsConditionsData = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(req) {
    var _res$data7;
    var res, _res$data8;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return fetcher(req).get("/policies/terms-and-conditions");
        case 1:
          res = _context4.v;
          if (!(res !== null && res !== void 0 && (_res$data7 = res.data) !== null && _res$data7 !== void 0 && _res$data7.success)) {
            _context4.n = 2;
            break;
          }
          return _context4.a(2, res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.data);
        case 2:
          return _context4.a(2, null);
      }
    }, _callee4);
  }));
  return function api__fetchTermsConditionsData(_x4) {
    return _ref4.apply(this, arguments);
  };
}();